(() => {
  const root = document.querySelector('[data-sm-hero]');
  const slides = root ? [...root.querySelectorAll('[data-sm-slide]')] : [];
  const dots = root ? [...root.querySelectorAll('[data-sm-dot]')] : [];
  let active = 0;
  let timer;

  function show(index) {
    if (!slides.length) return;
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const selected = slideIndex === active;
      slide.hidden = !selected;
      slide.classList.toggle('is-active', selected);
    });
    dots.forEach((dot, dotIndex) => {
      const selected = dotIndex === active;
      dot.classList.toggle('is-active', selected);
      dot.toggleAttribute('aria-current', selected);
    });
  }

  function autoplay() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || slides.length < 2) return;
    clearInterval(timer);
    timer = setInterval(() => show(active + 1), 7000);
  }

  dots.forEach((dot, index) => dot.addEventListener('click', () => {
    show(index);
    autoplay();
  }));
  show(0);
  autoplay();

  const tabs = [...document.querySelectorAll('[data-sm-tab]')];
  const panels = [...document.querySelectorAll('[data-sm-panel]')];
  const discoverLink = document.querySelector('[data-sm-discover]');

  function updateColorCounts(scope = document) {
    const data = window.StoreForgeSimpleModernLinkedProducts;
    if (!data?.groups || !data?.byHandle) return;
    scope.querySelectorAll('[data-sm-product-card]').forEach((card) => {
      const handle = card.dataset.productHandle;
      const group = data.groups[data.byHandle[handle]];
      if (!group?.items?.length) return;
      const colorCount = new Set(group.items.map((item) => item.c).filter(Boolean)).size;
      const sizeCount = new Set(group.items.map((item) => item.s).filter(Boolean)).size;
      const label = card.querySelector('[data-sm-color-count]');
      if (!label) return;
      if (colorCount > 1) label.textContent = `${colorCount} Colors Available`;
      else if (sizeCount > 1) label.textContent = `${sizeCount} Sizes Available`;
      else label.hidden = true;
    });
  }

  function syncRail(panel) {
    const rail = panel?.querySelector('[data-sm-rail]');
    const progress = panel?.querySelector('[data-sm-progress]');
    if (!rail || !progress) return;
    const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    const ratio = max ? rail.scrollLeft / max : 0;
    const visibleRatio = Math.min(1, rail.clientWidth / Math.max(rail.scrollWidth, 1));
    progress.style.width = `${Math.max(16, visibleRatio * 100)}%`;
    progress.style.transform = `translateX(${ratio * Math.max(0, (1 / visibleRatio - 1) * 100)}%)`;
  }

  function bindRail(panel) {
    const rail = panel.querySelector('[data-sm-rail]');
    if (!rail || rail.dataset.smBound === 'true') return;
    rail.dataset.smBound = 'true';
    panel.querySelector('[data-sm-rail-previous]')?.addEventListener('click', () => {
      rail.scrollBy({ left: -rail.clientWidth * .82, behavior: 'smooth' });
    });
    panel.querySelector('[data-sm-rail-next]')?.addEventListener('click', () => {
      rail.scrollBy({ left: rail.clientWidth * .82, behavior: 'smooth' });
    });
    rail.addEventListener('scroll', () => syncRail(panel), { passive: true });
    syncRail(panel);
  }

  function activateTab(key) {
    tabs.forEach((tab) => tab.setAttribute('aria-selected', String(tab.dataset.smTab === key)));
    panels.forEach((panel) => {
      const selected = panel.dataset.smPanel === key;
      panel.hidden = !selected;
      panel.classList.toggle('is-active', selected);
      if (selected) {
        if (discoverLink) discoverLink.href = panel.dataset.collectionUrl || '/collections/all';
        bindRail(panel);
        updateColorCounts(panel);
      }
    });
  }

  tabs.forEach((tab) => tab.addEventListener('click', () => activateTab(tab.dataset.smTab)));
  panels.forEach(bindRail);
  updateColorCounts();
  window.addEventListener('load', () => {
    updateColorCounts();
    panels.forEach(syncRail);
  }, { once: true });
  window.addEventListener('resize', () => panels.forEach(syncRail), { passive: true });

  const menuButton = document.querySelector('[data-sm-menu-toggle]');
  const menu = document.querySelector('[data-sm-menu]');
  const navItems = [...document.querySelectorAll('[data-sm-nav-item]')];
  const menuGroups = [...document.querySelectorAll('[data-sm-menu-group]')];

  function closeNavItems(except) {
    navItems.forEach((item) => {
      if (item !== except) item.removeAttribute('open');
    });
  }

  navItems.forEach((item) => {
    item.querySelector(':scope > summary')?.addEventListener('click', (event) => {
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      event.preventDefault();
      closeNavItems(item);
      item.setAttribute('open', '');
    });
    item.addEventListener('toggle', () => {
      if (item.open) closeNavItems(item);
    });
    item.addEventListener('mouseenter', () => {
      if (!window.matchMedia('(min-width: 750px)').matches) return;
      closeNavItems(item);
      item.setAttribute('open', '');
    });
    item.addEventListener('mouseleave', () => {
      if (window.matchMedia('(min-width: 750px)').matches) item.removeAttribute('open');
    });
  });

  menuGroups.forEach((group) => {
    const toggle = group.querySelector('[data-sm-menu-group-toggle]');
    toggle?.addEventListener('click', () => {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      const opening = !group.classList.contains('is-open');
      group.closest('[data-sm-mega-menu]')?.querySelectorAll('[data-sm-menu-group].is-open').forEach((other) => {
        if (other !== group) {
          other.classList.remove('is-open');
          other.querySelector('[data-sm-menu-group-toggle]')?.setAttribute('aria-expanded', 'false');
        }
      });
      group.classList.toggle('is-open', opening);
      toggle.setAttribute('aria-expanded', String(opening));
    });
  });

  document.addEventListener('click', (event) => {
    if (window.matchMedia('(min-width: 750px)').matches && !event.target.closest('[data-sm-header]')) closeNavItems();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeNavItems();
    menu?.classList.remove('is-open');
    menuButton?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('sm-menu-open');
  });

  menuButton?.addEventListener('click', () => {
    const expanded = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded', String(!expanded));
    menu?.classList.toggle('is-open', !expanded);
    document.body.classList.toggle('sm-menu-open', !expanded);
    if (expanded) {
      closeNavItems();
      menuGroups.forEach((group) => {
        group.classList.remove('is-open');
        group.querySelector('[data-sm-menu-group-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    }
  });
})();
